import { SET_PRELOADER } from '../../../helpers/action-types';

export const ICON = {
    NONE: 'none',
    SPINNER: 'spinner',
    EXCLAMATION: 'exclamation'
};

export function setPreloader(message, icon) {
    return {
        type: SET_PRELOADER,
        message,
        icon
    };
}